"use client";
import { usePathname } from "next/navigation";
import React from "react";

const HIDDEN_PATHS = [
  "campaigns",
  "register",
  "degrees/forgotpassword",
  "delete-my-account-otp",
  "degrees/email",
  "degrees/prospectus",
  "degrees/resetpassword",
  "/whatuni-mobile-app",
  "pgs/prospectus",
  "pgs/email",
];

const FooterVisibilityWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const pathname = usePathname();
  const hideFooter = HIDDEN_PATHS.some((path) => pathname?.includes(path));

  if (hideFooter) return null;

  return <>{children}</>;
};

export default FooterVisibilityWrapper;
